var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('swiper',{ref:"mySwiper_tab01",staticClass:"swiper_tab01",attrs:{"options":_vm.swiperOption_tab01}},_vm._l((_vm.list),function(item,index){return _c('swiper-slide',{key:index},[_c(item.component,{tag:"component"})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }